/*** Test Product Page **/
if(document.querySelector('.test-2-variant-1')){
    const elem = document.querySelector('[data-product-photos]');
    const flkty = Flickity.data(elem);

    // Resize image to left
    flkty.options.cellAlign = 'left';
    flkty.resize();

    window.handleSlideChangeThumbnailMove = (productContainer)=>{
        // This function will move the thumbnails if needed:
        if (!productContainer) return;

        const selectedThumbnail = productContainer.querySelector('.product__thumb.is-active');
        const thumbnailScroll = productContainer.querySelector('[data-product-thumbs] .product__thumbs--scroller');

        if (!thumbnailScroll || !selectedThumbnail) return;

        const thumbRect = selectedThumbnail.getBoundingClientRect();
        const containerRect = thumbnailScroll.getBoundingClientRect();

        const thumbCenter = thumbRect.left + thumbRect.width / 2;
        const containerCenter = containerRect.left + containerRect.width / 2;

        const scrollAdjustment = thumbCenter - containerCenter;

        thumbnailScroll.scrollBy({
            left: scrollAdjustment,
            behavior: "smooth"
        });
    }
}

/*** Test Product Page End**/


/**** Test 6 Cart ***********/
class CartDrawerTest {
    constructor(cartDrawer) {
        this.cartDrawer = cartDrawer;
        this.debounceTimer = null; 
        
        this.init();
        
        this.setupObserver();
    }


    init() {
        this.cartFooter = this.cartDrawer.querySelector('.unicorn_cart_footer .unicorn_cart_block');
        this.cartCheckoutBtn = this.cartDrawer.querySelector('#unicorn_checkout_submit');

        this.createNewFooter();
        this.modifyCheckoutBtn();
    }


    debounce(callback, delay) {
        return (...args) => {
            clearTimeout(this.debounceTimer);
            this.debounceTimer = setTimeout(() => callback.apply(this, args), delay);
        };
    }

    setupObserver() {
        this.observer = new MutationObserver(this.debounce((mutations) => {
            const isExternalMutation = mutations.some(mutation => {
                return !mutation.target.closest('.test-6-cart-footer');
            });

            if (isExternalMutation) {
                this.handleCartUpdate();
            }
        }, 300));

        this.startObserver();
    }

    startObserver() {
        if (this.cartDrawer) {
            this.observer.observe(this.cartDrawer, { childList: true, subtree: true, characterData: true });
        }
    }

    handleCartUpdate() {
        this.observer.disconnect();
        this.init();
        this.startObserver();
    }

    formatMoney(cents) {
        return '$' + (cents / 100).toFixed(2);
    }

    modifyCheckoutBtn() {
        if (!this.cartCheckoutBtn) return;

        const btnText = this.cartCheckoutBtn.querySelector('.unicorn_cart_checkout_button_text');
        if (!btnText) return;
        if (btnText.querySelector('svg')) return; 
        btnText.innerHTML = `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z" fill="white" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11" fill="black"/>
                <path d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>Secure Checkout</span>`;
    }

    detailsTrigger() {
        const trigger = this.cartDrawer.querySelector('#detailsTrigger');
        const wrapper = this.cartDrawer.querySelector('#detailsWrapper');

        if (trigger && wrapper) {
            const isOpen = wrapper.classList.toggle('is-open');
            trigger.textContent = isOpen ? 'Hide Details' : 'Show Details';
        }
    }

    createNewFooter() {
        if (!this.cartFooter) return;
        const existingFooter = this.cartFooter.querySelector('.test-6-cart-footer');
        if (existingFooter) {
            existingFooter.remove();
        }

        const finalTotalValue = unicornCartData.totalPrice.value; 
        const savingsValue = unicornCartData.totalSavings.totalWithCompareAtPrice.value; 
        const subtotalValue = finalTotalValue + savingsValue; 
        
        const savingsAmountFormatted = this.formatMoney(savingsValue);
        const savingsAmountBadge = savingsAmountFormatted.replace('.00', '');

        const div = document.createElement('div');
        div.classList.add('test-6-cart-footer'); 
        
        div.innerHTML = `
            <div class="test-6-details-wrapper" id="detailsWrapper">
                <div class="test-6-subtotal-details-container">
                    <div class="detail-row">
                        <span>Subtotal</span>
                        <span class='test-6-subtotal-value'>${this.formatMoney(subtotalValue)}</span>
                    </div>
                    <div class="detail-row">
                        <span>Discount</span>
                        <span class="discount-text">-${savingsAmountFormatted}</span>
                    </div>
                    <div class="detail-row">
                        <span>Shipping &amp; Taxes</span>
                        <span class="muted-text">Calculated At Checkout</span>
                    </div>
                    <hr class="detail-line">
                </div>
            </div>
            <div class="test-6-subtotal-container">
                <p class="test-6-subtotal-text">Total</p>
                <div class="test-6-pricing-container">
                    ${savingsValue > 0 ? `<span class="price-badge">${savingsAmountBadge} Off</span>` : ''}
                    ${savingsValue > 0 ? `<span class="price-crossed">${this.formatMoney(subtotalValue)}</span>` : ''}
                    <span class="price-final"><b>${unicornCartData.totalPrice.money}</b></span>
                </div>
            </div>
            <button class="test-6-details-trigger" id="detailsTrigger">Show Details</button>
        `;
            
        this.cartFooter.appendChild(div);

        const btn = div.querySelector('.test-6-details-trigger');
        if (btn) {
            btn.addEventListener('click', this.detailsTrigger.bind(this));
        }
    }
}

// Initialization logic remains exactly the same
const isTest6 = document.querySelector('.test-6-variant-1');
if (isTest6) {
    const checkUnicorn = setInterval(() => {
        if (typeof unicornCartData != 'undefined' && document.querySelector('#unicorn-cart-dialog')) {
            clearInterval(checkUnicorn);
            new CartDrawerTest(document.querySelector('#unicorn-cart-dialog'));
        }
    }, 500);
}
/**** Test 6 Cart End  ******/



/**** Test 10 Mobile Sticky ATC Start ******/
class MobileStickyATC {
    constructor() {
        this.variant1 = document.querySelector('.test-10-variant-1');
        this.variant2 = document.querySelector('.test-10-variant-2');
        this.stickyContainer = null;
        this.mainATC = document.querySelector('form[action="/cart/add"] [name="add"]');

        if (!this.mainATC) return;

        this.init();
    }

    init() {
        this.createStickyBar();
        this.setupEventListeners();
        this.handleScroll(); // Initial check
    }

    createStickyBar() {
        if (document.querySelector('.custom-sticky-atc')) return;

        this.stickyContainer = document.createElement('div');
        this.stickyContainer.classList.add('custom-sticky-atc');
        if (this.variant1) this.stickyContainer.classList.add('variant-1');
        if (this.variant2) this.stickyContainer.classList.add('variant-2');

        const productTitle = document.querySelector('.product-single__title')?.innerText || '';
        const mainImage = document.querySelector('.product-image-main img');
        const productImageSrc = mainImage?.src || '';
        const productImageSwipeSrc = mainImage?.getAttribute('data-photoswipe-src') ?? '';
        const currentPrice = this.getCurrentPrice();
        const currentVariant = this.getCurrentVariantName();

        const spinnerHtml = `
            <span class="unicorn_loader" style="background-color: rgba(0, 0, 0, 0);">
                <svg xmlns="http://www.w3.org/2000/svg" class="unicorn_spinner" viewBox="0 0 66 66">
                    <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" stroke="rgb(255, 255, 255)" style="stroke:rgb(255, 255, 255)"></circle>
                </svg>
            </span>`;

        let html = '';
        if (this.variant1) {
            html = `
                <div class="sticky-atc-wrapper">
                    <button type="button" class="btn btn--full sticky-atc-btn">
                        <span class="sticky-btn-text">Add to cart - ${currentPrice}</span>
                        ${spinnerHtml}
                    </button>
                </div>
            `;
        } else if (this.variant2) {
            html = `
                <div class="sticky-atc-wrapper">
                    <div class="sticky-product-info">
                        <img src="${productImageSrc ? productImageSrc : productImageSwipeSrc}" alt="${productTitle}" class="sticky-product-image">
                        <div class="sticky-product-text">
                            <span class="sticky-product-title">${productTitle}</span>
                            <span class="sticky-variant-name">${currentVariant}</span>
                        </div>
                    </div>
                    <button type="button" class="btn btn--full sticky-atc-btn">
                        <span class="sticky-btn-text">Add to cart - ${currentPrice}</span>
                        ${spinnerHtml}
                    </button>
                </div>
            `;
        }

        this.stickyContainer.innerHTML = html;
        document.body.appendChild(this.stickyContainer);

        this.stickyContainer.querySelector('.sticky-atc-btn')?.addEventListener('click', () => {
            this.mainATC.click();
        });
    }

    getCurrentPrice() {
        const priceElem = document.querySelector('[data-product-price]') || document.querySelector('.product__price');
        if (!priceElem) return '';
        let price = priceElem.innerText.replace(/[^0-9.]/g, '');
        if (price && !price.includes('.')) price += '.00';
        else if (price && price.split('.')[1].length === 1) price += '0';
        return `$${price}`;
    }

    getCurrentVariantName() {
        const checkedInput = document.querySelector('.variant-input input:checked + label');
        return checkedInput ? checkedInput.innerText : '';
    }

    setupEventListeners() {
        window.addEventListener('scroll', () => this.handleScroll());

        // Update on variant change
        document.querySelectorAll('.variant-input input').forEach(input => {
            input.addEventListener('change', () => {
                setTimeout(() => this.updateStickyBar(), 100);
            });
        });

        // Update on price changes
        const priceElem = document.querySelector('[data-product-price]') || document.querySelector('.product__price');
        if (priceElem) {
            const observer = new MutationObserver(() => this.updateStickyBar());
            observer.observe(priceElem, { childList: true, characterData: true, subtree: true });
        }

        // Update on loading state changes
        if (this.mainATC) {
            const stateObserver = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'attributes' && (mutation.attributeName === 'aria-disabled' || mutation.attributeName === 'disabled')) {
                        this.syncLoadingState();
                    }
                });
            });
            stateObserver.observe(this.mainATC, { attributes: true });
            this.syncLoadingState(); // Initial check
        }
    }

    syncLoadingState() {
        if (!this.mainATC || !this.stickyContainer) return;

        const isLoading = this.mainATC.getAttribute('aria-disabled') === 'true' || this.mainATC.hasAttribute('disabled');
        const stickyBtn = this.stickyContainer.querySelector('.sticky-atc-btn');
        if (stickyBtn) {
            if (isLoading) {
                stickyBtn.classList.add('is-loading');
                stickyBtn.setAttribute('disabled', 'disabled');
            } else {
                stickyBtn.classList.remove('is-loading');
                stickyBtn.removeAttribute('disabled');
            }
        }
    }

    updateStickyBar() {
        const currentPrice = this.getCurrentPrice();
        const currentVariant = this.getCurrentVariantName();

        const btnText = this.stickyContainer?.querySelector('.sticky-btn-text');
        if (btnText) btnText.innerText = `Add to cart - ${currentPrice}`;

        const variantNameElem = this.stickyContainer?.querySelector('.sticky-variant-name');
        if (variantNameElem) variantNameElem.innerText = currentVariant;

        const imageElem = this.stickyContainer?.querySelector('.sticky-product-image');
        if (imageElem) {
            const mainImage = document.querySelector('.product-image-main img');
            if (mainImage) {
                imageElem.src = mainImage.src || '';
                imageElem.srcset = mainImage.srcset || '';
            }
        }
    }

    handleScroll() {
        if (!this.mainATC || !this.stickyContainer) return;

        const rect = this.mainATC.getBoundingClientRect();
        const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;

        if (!isVisible && rect.top < 0) {
            this.stickyContainer.classList.add('is-visible');
        } else {
            this.stickyContainer.classList.remove('is-visible');
        }
    }
}

const isTest10Variant1 = document.querySelector('.test-10-variant-1');
const isTest10Variant2 = document.querySelector('.test-10-variant-2');

if (isTest10Variant1 || isTest10Variant2) {
    new MobileStickyATC();
}
/**** Test 10 Mobile Sticky ATC End ******/


/**** Test 9 Product Wall VCN Start ******/
class ProductWallVCN {
    constructor() {
        this.categories = {
            scooter: {
                title: 'ALL SCOOTERS',
                targets: [
                    'pro-scooters-1',
                    'mg-series-scooters',
                    'madd-viral-range',
                    'madd-origin-range',
                    'junior-commuter-tramp-scooters',
                    'teen-adult-scooters',
                ],
                subCollections: [
                    {
                        title: 'MG SERIES',
                        handle: 'mg-series-scooters',
                        url: '/collections/mg-series-scooters',
                        image: '//www.maddgear.com.au/cdn/shop/collections/MG_Series_2_400x.jpg?v=1774554655'
                    },
                    {
                        title: 'MADD VIRAL RANGE',
                        handle: 'madd-viral-range',
                        url: '/collections/madd-viral-range',
                        image: '//www.maddgear.com.au/cdn/shop/collections/change2_400x.jpg?v=1756956973'
                    },
                    {
                        title: 'MADD ORIGIN RANGE',
                        handle: 'madd-origin-range',
                        url: '/collections/madd-origin-range',
                        image: '//www.maddgear.com.au/cdn/shop/collections/Origin_400x.jpg?v=1771880972'
                    },
                    {
                        title: 'JUNIOR, KICK & TRAMP',
                        handle: 'junior-commuter-tramp-scooters',
                        url: '/collections/junior-commuter-tramp-scooters',
                        image: '//www.maddgear.com.au/cdn/shop/collections/Bounce_Banner_400x.jpg?v=1749010918'
                    },
                    {
                        title: 'TEEN & ADULT SCOOTERS',
                        handle: 'teen-adult-scooters',
                        url: '/collections/teen-adult-scooters',
                        image: '//www.maddgear.com.au/cdn/shop/collections/grn250_400x.jpg?v=1759192127'
                    },
                    {
                        title: 'SALE',
                        handle: 'sale',
                        url: '/collections/sale',
                        image: '//www.maddgear.com.au/cdn/shop/files/NEW_1080x.png?v=1773310453'
                    }
                ]
            }
        };

        this.init();
    }

    init() {
        const currentHandle = window.location.pathname.split('/').pop();
        if (!currentHandle) return;

        // Find matching category
        let activeCategoryKey = null;
        for (const [key, category] of Object.entries(this.categories)) {
            if (category.targets.includes(currentHandle) || (currentHandle === 'sale' && key === 'scooter')) {
                activeCategoryKey = key;
                break;
            }
        }

        if (activeCategoryKey) {
            this.render(activeCategoryKey);
        }
    }

    getProductCount() {
        const countEl = document.querySelector('.collection-filter__item--count');
        if (countEl) {
            const countMatch = countEl.innerText.match(/\d+/);
            if (countMatch) {
                return ` <span class="product-wall-vcn__count">(${countMatch[0]})</span>`;
            }
        }
        return '';
    }

    render(categoryKey) {
        const currentHandle = window.location.pathname.split('/').pop();
        const category = this.categories[categoryKey];
        const subCollections = [...category.subCollections];
        const productCount = this.getProductCount();

        // Move active collection to front
        const activeIndex = subCollections.findIndex(item => item.handle === currentHandle);
        if (activeIndex > -1) {
            const activeItem = subCollections.splice(activeIndex, 1)[0];
            activeItem.isActive = true;
            subCollections.unshift(activeItem);
        }

        const vcnHtml = `
            <div class="product-wall-vcn">
                    <h2 class="product-wall-vcn__title">${category.title}${productCount}</h2>
                   <div class="product-wall-vcn__grid">
                            ${subCollections.map(item => `
                                <a href="${item.url}" class="product-wall-vcn__item ${item.isActive ? 'is-active' : ''}">
                                    <div class="product-wall-vcn__image-wrapper">
                                        <img src="${item.image}" alt="${item.title}" class="product-wall-vcn__image">
                                    </div>
                                    <span class="product-wall-vcn__item-title">${item.title}</span>
                                </a>
                            `).join('')}
                        </div>
            </div>
        `;

        const injectionPoint = document.querySelector('.collection-grid') || document.querySelector('#MainContent .grid');
        if (injectionPoint) {
            injectionPoint.insertAdjacentHTML('beforebegin', vcnHtml);
        }
    }
}

const isTest9 = document.querySelector('.test-9-variant-1');
if (isTest9) {
    new ProductWallVCN();
}
/**** Test 9 Product Wall VCN End ******/
/***** Test 8 PDP First Viewport ******/
class PDPFirstViewport8 {
    constructor() {
        this.variant1 = document.querySelector('.test-8-variant-1');
        this.variant2 = document.querySelector('.test-8-variant-2');
        this.variant3 = document.querySelector('.test-8-variant-3');

        this.init();
    }

    init() {
        this.renderBenefitsGrid();

        // Only beenfit needed, remove all else
        // if (this.variant1 || this.variant3) {
        //     this.handleLayoutShifts();
        //     this.replaceBreadcrumbDividers();
        // }

        // if (this.variant1) {
        //     this.initEnhancedGallery();
        //     if (window.innerWidth > 768) {
        //         this.initDesktopThumbnails();
        //     }
        // }
    }

    replaceBreadcrumbDividers() {
        const dividers = document.querySelectorAll('.breadcrumb__divider');
        if (dividers.length === 0) return;

        const svgIcon = `
           <svg xmlns="http://www.w3.org/2000/svg" width="7" height="6" viewBox="0 0 7 6" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.3182 2.51419C6.49394 2.67894 6.49394 2.94606 6.3182 3.11081L3.76819 5.50144C3.59246 5.66619 3.30753 5.66619 3.1318 5.50144C2.95606 5.33668 2.95606 5.06957 3.1318 4.90481L5.36361 2.8125L3.1318 0.720193C2.95606 0.555433 2.95606 0.288323 3.1318 0.123562C3.30753 -0.0411875 3.59246 -0.0411875 3.76819 0.123562L6.3182 2.51419ZM0.768195 0.123562L3.3182 2.51419C3.49394 2.67894 3.49394 2.94606 3.3182 3.11081L0.768195 5.50144C0.592465 5.66619 0.307535 5.66619 0.131805 5.50144C-0.043935 5.33668 -0.043935 5.06957 0.131805 4.90481L2.3636 2.8125L0.131805 0.720193C-0.043935 0.555433 -0.043935 0.288323 0.131805 0.123562C0.307535 -0.0411875 0.592465 -0.0411875 0.768195 0.123562Z" fill="#6A6A6A"/>
            </svg>
        `;

        dividers.forEach(divider => {
            if (!divider.dataset.breadcrumbModified) {
                divider.innerHTML = svgIcon;
                divider.dataset.breadcrumbModified = "true";
            }
        });
    }

    renderBenefitsGrid() {
        const paymentButtons = document.querySelector('.product-single__form .payment-buttons');
        const restockBtn = document.querySelector('.restock-rocket-button-container')
        if (!paymentButtons || document.querySelector('.test-8-benefits')) return;

        const benefitsHtml = `
            <div class="test-8-benefits">
                <div class="test-8-benefit-item">
                    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="30" viewBox="0 0 35 30" fill="none">
                        <path d="M9 15C9 16.6811 9.49852 18.3245 10.4325 19.7223C11.3665 21.1202 12.694 22.2096 14.2472 22.853C15.8004 23.4963 17.5094 23.6646 19.1583 23.3367C20.8071 23.0087 22.3217 22.1991 23.5104 21.0104C24.6991 19.8217 25.5087 18.3071 25.8367 16.6583C26.1646 15.0094 25.9963 13.3004 25.353 11.7472C24.7096 10.194 23.6202 8.8665 22.2223 7.93251C20.8245 6.99852 19.1811 6.5 17.5 6.5C15.1237 6.50894 12.8429 7.43616 11.1344 9.08778L9 11.2222" stroke="#0A0A0A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M9 6.5V11.5H14" stroke="#0A0A0A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>

                    <span>14 Day<br>Returns</span>
                </div>
                <div class="test-8-benefit-item">
                    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="24" viewBox="0 0 35 24" fill="none">
                        <path d="M25.5 5H9.5C8.39543 5 7.5 5.89543 7.5 7V17C7.5 18.1046 8.39543 19 9.5 19H25.5C26.6046 19 27.5 18.1046 27.5 17V7C27.5 5.89543 26.6046 5 25.5 5Z" stroke="#0A0A0A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M7.5 10H27.5" stroke="#0A0A0A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span>Secure<br>Payment</span>
                </div>
                <div class="test-8-benefit-item">
                    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="24" viewBox="0 0 35 24" fill="none">
                        <path d="M25.5 12.9487C25.5 17.6979 22 20.0725 17.84 21.4498C17.6222 21.5199 17.3855 21.5165 17.17 21.4403C13 20.0725 9.5 17.6979 9.5 12.9487V6.29979C9.5 6.04788 9.60536 5.80628 9.79289 5.62815C9.98043 5.45002 10.2348 5.34995 10.5 5.34995C12.5 5.34995 15 4.21014 16.74 2.76638C16.9519 2.59446 17.2214 2.5 17.5 2.5C17.7786 2.5 18.0481 2.59446 18.26 2.76638C20.01 4.21964 22.5 5.34995 24.5 5.34995C24.7652 5.34995 25.0196 5.45002 25.2071 5.62815C25.3946 5.80628 25.5 6.04788 25.5 6.29979V12.9487Z" stroke="#0A0A0A" stroke-width="1.18799" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M14.5 11.5L16.8333 13.5L21.5 9.5" stroke="#0A0A0A" stroke-width="1.18799" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span>2-Year<br>Warranty</span>
                </div>
            </div>
        `;
        if (restockBtn) restockBtn.insertAdjacentHTML('afterend', benefitsHtml);
        else
            paymentButtons.insertAdjacentHTML('afterend', benefitsHtml);
    }

    handleLayoutShifts() {
        // Move reviews above title on mobile
        const reviewSummary = document.querySelector('.product-single__meta .yotpo-widget-instance') || document.querySelector('.yotpo-widget-instance');
        const productTitle = document.querySelector('.product-single__title');

        if (window.innerWidth <= 768 && reviewSummary && productTitle) {
            productTitle.parentNode.insertBefore(reviewSummary, productTitle);
        }
    }

    initEnhancedGallery() {
        // Standard Test 2 thumbnails logic handled by CSS and theme.js
        // Custom arrows and save XX badge will be added here
        this.addGalleryArrows();
    }

    addGalleryArrows() {
        const photosContainer = document.querySelector('[data-product-photos]');
        if (!photosContainer || photosContainer.querySelector('.test-8-gallery-arrow')) return;

        const leftArrow = document.createElement('button');
        leftArrow.className = 'test-8-gallery-arrow is-left';
        leftArrow.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16" fill="none">
        <path d="M2.30001 8.70002L8.30001 14.6C8.70001 15 9.40001 15 9.80001 14.6C10.2 14.2 10.2 13.5 9.80001 13.1L4.50001 8.00002L9.70001 2.80002C10.1 2.40003 10.1 1.70002 9.70001 1.30002C9.30001 0.900025 8.60001 0.900025 8.20001 1.30002L2.20001 7.30002C1.90001 7.70002 1.90001 8.30002 2.30001 8.70002Z" fill="white"/>
        </svg>
        `;

        const rightArrow = document.createElement('button');
        rightArrow.className = 'test-8-gallery-arrow is-right';
        rightArrow.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16" fill="none">
                <path d="M9.70002 7.29998L3.70002 1.39998C3.30002 0.999976 2.60002 0.999976 2.20002 1.39998C1.80002 1.79998 1.80002 2.49998 2.20002 2.89998L7.50002 7.99998L2.30002 13.2C1.90002 13.6 1.90002 14.3 2.30002 14.7C2.70002 15.1 3.40002 15.1 3.80002 14.7L9.80002 8.69998C10.1 8.29998 10.1 7.69998 9.70002 7.29998Z" fill="white"/>
            </svg>
        `;

        photosContainer.appendChild(leftArrow);
        photosContainer.appendChild(rightArrow);

        const flkty = Flickity.data(photosContainer);
        if (flkty) {
            leftArrow.addEventListener('click', () => flkty.previous());
            rightArrow.addEventListener('click', () => flkty.next());

            const updateArrows = () => {
                leftArrow.style.opacity = flkty.selectedIndex === 0 ? '0.4' : '1';
                rightArrow.style.opacity = flkty.selectedIndex === flkty.cells.length - 1 ? '0.4' : '1';
            };

            flkty.on('select', updateArrows);
            updateArrows();
        }
    }

    initDesktopThumbnails() {
        const thumbScroller = document.querySelector('.product__thumbs--scroller');
        const mainPhotos = document.querySelector('[data-product-photos]');
        if (!thumbScroller || !mainPhotos) return;

        // Sync height
        const syncHeight = () => {
            thumbScroller.style.maxHeight = `${mainPhotos.offsetHeight}px`;
        };
        syncHeight();
        window.addEventListener('resize', syncHeight);

        // Add arrows
        if (thumbScroller.querySelector('.test-8-thumb-arrow')) return;

        // Use theme's chevron SVG for arrows
        const chevronSvg = `<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-down" viewBox="0 0 28 16"><path d="M1.57 1.59l12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none" fill-rule="evenodd"></path></svg>`;

        const topArrow = document.createElement('button');
        topArrow.className = 'test-8-thumb-arrow is-top';
        topArrow.innerHTML = chevronSvg;
        topArrow.style.transform = 'rotate(180deg)';

        const bottomArrow = document.createElement('button');
        bottomArrow.className = 'test-8-thumb-arrow is-bottom';
        bottomArrow.innerHTML = chevronSvg;

        thumbScroller.parentNode.insertBefore(topArrow, thumbScroller);
        thumbScroller.parentNode.appendChild(bottomArrow);

        const updateThumbArrows = () => {
            const isAtTop = thumbScroller.scrollTop <= 5;
            const isAtBottom = Math.ceil(thumbScroller.scrollTop + thumbScroller.clientHeight) >= thumbScroller.scrollHeight - 5;

            // Only show arrows if scrolling is actually possible
            const canScroll = thumbScroller.scrollHeight > thumbScroller.clientHeight;

            topArrow.style.display = (isAtTop || !canScroll) ? 'none' : 'flex';
            bottomArrow.style.display = (isAtBottom || !canScroll) ? 'none' : 'flex';
        };

        thumbScroller.addEventListener('scroll', updateThumbArrows);
        topArrow.addEventListener('click', () => thumbScroller.scrollBy({ top: -150, behavior: 'smooth' }));
        bottomArrow.addEventListener('click', () => thumbScroller.scrollBy({ top: 150, behavior: 'smooth' }));

        // Initial check and observers
        setTimeout(updateThumbArrows, 100);

        const resizeObserver = new ResizeObserver(() => {
            syncHeight();
            updateThumbArrows();
        });
        resizeObserver.observe(thumbScroller);
        resizeObserver.observe(mainPhotos);
    }
}

const isTest8 = document.querySelector('.test-8-variant');
if (isTest8) {
    new PDPFirstViewport8();
}
/***** Test 8 PDP First Viewport End ******/
